// extracted by mini-css-extract-plugin
export var createdDate = "_kk-1";
export var divider = "_kk-2";
export var headerDivider = "_kk-3";
export var messagesCard = "_kk-0";
export var messagesContainer = "_kk-6";
export var messagesContainerWrapper = "_kk-4";
export var showLeftPanelButton = "_kk-8";
export var topButtons = "_kk-7";
export var withPadding = "_kk-5";